//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class BranchRelationTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[BranchRelationType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch-relation-type/detail', {'params':params});
	};

	//GeneratorFlag:[BranchRelationType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch-relation-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}